import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

const AdminFooter = () => {
  return (
    <Box sx={{ textAlign: 'center', mt: 8, mb: 4 }}>
      <Typography>© Kuetianshub.com 2023</Typography>
    </Box>
  );
};

export default AdminFooter;
